export default __webpack_public_path__ + "static/media/detail_mobile_10_6.b67e260d.jpg";